var _circle, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23.75vw",
    height: "11.11vw",
    viewBox: "0 0 342 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 167.811,
    cy: 76.8112,
    r: 23.8112,
    fill: "#3EA400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.817 78.5263L163.584 84.1221C164.21 84.73 165.239 84.73 165.849 84.1221L178.042 72.2914C178.669 71.6835 178.669 70.7015 178.042 70.0936C177.416 69.4857 176.404 69.4857 175.777 70.0936L164.724 80.8176L160.082 76.3285C159.455 75.7206 158.443 75.7206 157.817 76.3285C157.19 76.9364 157.19 77.9184 157.817 78.5263Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 1,
    y: 1,
    width: 340,
    height: 158,
    rx: 23,
    stroke: "#3EA400",
    strokeWidth: 2,
    strokeDasharray: "10 8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDone);
export default __webpack_public_path__ + "static/media/uploadDone.baab0079b3b40f4d088b49080b940206.svg";
export { ForwardRef as ReactComponent };